import { PointsBundle } from '../../types/PointsBundle';

export const applyMostPopular = (bundle: PointsBundle): PointsBundle => ({
  ...bundle,
  isMostPopular: true,
});

export const applyRecommended = (bundle: PointsBundle): PointsBundle => ({
  ...bundle,
  isRecommended: true,
});
